import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsRentalPeriod() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Rental period' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure rental period settings here.</Text>
    </div>
  );
}
